import { Outlet } from 'react-router';

import { DocumentListProvider } from '@/features/document-list/document-list-context';

export function ScheduleCheckDetailWrapper() {
  return (
    <DocumentListProvider>
      <Outlet />
    </DocumentListProvider>
  );
}
